/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppDispatch } from 'store'
import { setCompareBy } from 'slices/comparison'
import { CompareBy } from 'types/enums'
import {
  removeAllSelections,
  fetchPoliciesAsync,
  fetchPolicyContentByIdAsync,
} from 'slices/comparison'

interface LoadComparisonArgs {
  codes: string[]
  selectedProductClassCover: { coverId?: number[] } | null
  filter: { effectiveDate: string | null }
  comparisonPolicies: any[] | null | undefined
  dispatch: AppDispatch
}

export async function loadComparisonByPolicyCodesHelper({
  codes,
  selectedProductClassCover,
  filter,
  comparisonPolicies,
  dispatch,
}: LoadComparisonArgs): Promise<'missing-covers' | 'no-match' | 'ok'> {
  const uniqueCodes = Array.from(new Set(codes.map((c) => c?.trim()).filter(Boolean)))
  if (uniqueCodes.length === 0) return 'no-match'

  if (!selectedProductClassCover?.coverId?.length) {
    return 'missing-covers'
  }

  await dispatch(removeAllSelections())

  // Ensure comparison mode is set to Company when loading by policy codes
  dispatch(setCompareBy(CompareBy.COMPANY))

  let policies = comparisonPolicies || []
  if (!policies.length) {
    const result: any = await dispatch(
      fetchPoliciesAsync({
        cover_id: selectedProductClassCover.coverId,
        date: filter.effectiveDate,
      }),
    )
    policies = result?.payload || []
  }

  const selectedPolicies = uniqueCodes
    .map((code) => policies?.find((p: any) => p.code === code))
    .filter(Boolean) as any[]

  if (selectedPolicies.length === 0) {
    return 'no-match'
  }

  await Promise.all(
    selectedPolicies.map((policy, index) =>
      dispatch(fetchPolicyContentByIdAsync({ policy: policy as any, slot: index })),
    ),
  )

  return 'ok'
}
